import React from "react";
import { Activity, Cpu, Database, FileText, Server, Globe, Network, Link, Bell } from "lucide-react";
import ServerStatusCard from "./ServerStatusCard";

export interface ServerStatusData {
  cpu: string;
  memory: string;
  disk: string;
  uptime: string;
  nginx_status?: string;
  matrix_status?: string;
  api_status?: string;
  active_connections?: string;
  last_updated?: string;
}

interface ServerStatusSectionProps {
  serverStatus: ServerStatusData;
}

const ServerStatusSection = ({ serverStatus }: ServerStatusSectionProps) => {
  const safeServerStatus = serverStatus || {
    cpu: "N/A",
    memory: "N/A",
    disk: "N/A",
    uptime: "N/A"
  };

  const getStatusColorClass = (status: string | undefined) => {
    if (!status) return "text-gray-400";
    return status === "aktivan" ? "text-green-400" : "text-red-400";
  };

  return (
    <section>
      <h2 className="text-xl mb-6 flex items-center gap-2 text-foreground/80">
        <Activity className="h-5 w-5" />
        Status Servera
        {safeServerStatus.last_updated && (
          <span className="text-xs text-muted-foreground ml-2">
            Ažurirano: {safeServerStatus.last_updated}
          </span>
        )}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <ServerStatusCard 
          title="CPU Opterećenje" 
          value={safeServerStatus.cpu} 
          icon={Cpu} 
        />
        <ServerStatusCard 
          title="Memorija" 
          value={safeServerStatus.memory} 
          icon={Server} 
        />
        <ServerStatusCard 
          title="Disk" 
          value={safeServerStatus.disk} 
          icon={Database} 
        />
        <ServerStatusCard 
          title="Uptime" 
          value={safeServerStatus.uptime} 
          icon={FileText} 
        />
        
        <ServerStatusCard 
          title="Nginx Status" 
          value={safeServerStatus.nginx_status || "N/A"} 
          icon={Globe}
          statusColor={getStatusColorClass(safeServerStatus.nginx_status)}
        />
        <ServerStatusCard 
          title="Matrix Status" 
          value={safeServerStatus.matrix_status || "N/A"} 
          icon={Network}
          statusColor={getStatusColorClass(safeServerStatus.matrix_status)}
        />
        <ServerStatusCard 
          title="API Status" 
          value={safeServerStatus.api_status || "N/A"} 
          icon={Link}
          statusColor={getStatusColorClass(safeServerStatus.api_status)}
        />
        <ServerStatusCard 
          title="Aktivne Konekcije" 
          value={safeServerStatus.active_connections || "0"} 
          icon={Bell} 
        />
      </div>
    </section>
  );
};

export default ServerStatusSection;
